import { combineReducers } from 'redux';
import { subjectsReducer } from './reducers/subjects-reducer';

export default combineReducers({
  subjectsReducer
});
